module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/mypage/es-MX/btn_vote-mini.png";